(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/limit-coverage-warning.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/limit-coverage-warning.js');

'use strict';

const Paper = svs.ui.ReactPaper;
const capitalizeString = svs.utils.format.capitalize;
const LimitCoverageWarning = _ref => {
  let {
    amount,
    hasGameAmountOverMaxLimit,
    isTwentyToTwentyFive,
    isUnderTwenty,
    maxLimit,
    product
  } = _ref;
  return React.createElement(Paper, {
    branding: "tur",
    className: "padding-v-1 padding-h-2 limit-coverage-warning"
  }, hasGameAmountOverMaxLimit ? React.createElement(React.Fragment, null, React.createElement("p", {
    className: "margin-bottom-0 f-medium"
  }, "Du kan inte l\xE4gga ditt spel p\xE5", ' ', capitalizeString(product, true), ' ', "f\xF6r", ' ', amount, ' ', "kronor just nu."), isUnderTwenty && React.createElement("p", {
    className: "margin-bottom-0"
  }, "Eftersom du \xE4r under 20 \xE5r g\xE4ller en maxgr\xE4ns p\xE5 1 000 kr."), isTwentyToTwentyFive && React.createElement("p", {
    className: "margin-bottom-0"
  }, "Eftersom du \xE4r under 25 \xE5r g\xE4ller en maxgr\xE4ns p\xE5 5 000 kr."), !isUnderTwenty && !isTwentyToTwentyFive && React.createElement("p", {
    className: "margin-bottom-0"
  }, "Eftersom den h\xF6gsta gr\xE4nsen du kan s\xE4tta \xE4r", ' ', maxLimit, ' ', "kr och spelet kostar mer \xE4n det."), React.createElement("p", {
    className: "margin-bottom-0"
  }, "Du kan s\xE4tta dina ins\xE4ttningsgr\xE4nser nu - men beh\xF6ver justera spelets belopp f\xF6rst.")) : React.createElement(React.Fragment, null, React.createElement("p", {
    className: "margin-bottom-0"
  }, "Ditt spel p\xE5", ' ', capitalizeString(product, true), ' ', "kostar", ' ', amount, ' ', "kr."), React.createElement("p", {
    className: "margin-bottom-0"
  }, "Med den gr\xE4ns du satt kan du tyv\xE4rr inte l\xE4gga detta spel.")));
};
svs.accountservicesReact.gameLimitDepositsForm.LimitCoverageWarning = LimitCoverageWarning;

 })(window);